export default "__VITE_ASSET__Y90Qfayu__"